/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
import React from 'react';

import { Button, Typography } from '@atoms';
import MediaField from '@organisms/MediaField';
import * as utils from '@utils/form';

import Form from '../Form';

import * as s from './styles.module.less';

const FORM_FIELD = {
  IMAGE: {
    name: 'image',
    rules: [{ required: true, message: 'Image is required' }],
    serialize: utils.imageSerialize,
    deserialize: utils.imageDeserialize,
  },
};

const ImageForm = ({ onFinish, disabled, initialValues: data }) => {
  const [form] = Form.useForm(FORM_FIELD);
  const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);

  const handleSubmit = React.useCallback(
    (values) => {
      onFinish(values);
      form.resetFields();
    },
    [form, onFinish],
  );

  return (
    <Form
      form={form}
      layout="vertical"
      wrapperCol={{ span: 24 }}
      onSerializedFinish={handleSubmit}
      initialValues={initialValues}
      component="div"
      className={s.padded}
    >
      <Typography.Title level={3}>Choose an image</Typography.Title>
      <MediaField {...FORM_FIELD.IMAGE} skipCrop disabled={disabled} />
      <Button type="customBlue" onClick={form.submit} disabled={disabled}>
        ADD IMAGE
      </Button>
    </Form>
  );
};

export default ImageForm;
